import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {EventService} from '../../../../core/services/event.service';
import {ELearningService} from '../../../../core/services/e-learning.service';
import * as events from 'node:events';
import {MatSelectionList} from '@angular/material/list';

@Component({
  selector: 'add-content-modal',
  templateUrl: './add-content-modal.component.html',
  styleUrls: ['./add-content-modal.component.scss'],
  standalone: false
})

export class AddContentModalComponent implements OnInit{
  organizationId;
  type;
  chosenIds;
  content: any = [];
  selectedItems = [];
  constructor(public dialogRef: MatDialogRef<AddContentModalComponent>, public eventService: EventService,
              public elearningService: ELearningService, @Inject(MAT_DIALOG_DATA) public data){

  }

  ngOnInit(){
    this.organizationId = this.data.organizationId;
    this.type = this.data.type;
    this.chosenIds = this.data.chosenIds;
    if (this.type === 'event') {
      this.getEvents();
    } else if (this.type === 'elearning') {
      this.getElearnings();
    }
  }

  getEvents(){
    this.eventService.getEventsForLearningPaths(this.organizationId).subscribe({
      next: (res: any) => {
        this.content = res;
        this.selectedItems = this.content.filter(item => this.chosenIds.includes(item.id));
      },
      error: (err) => {}
    });
  }

  getElearnings() {
    this.elearningService.findByOrganization(this.organizationId).subscribe({
      next: (res: any) => {
        this.content = res;
        this.selectedItems = this.content.filter(item => this.chosenIds.includes(item.id));
      },
      error: (err) => {}
    });
  }

  getImage(name) {
    return this.eventService.getFileStream(name);
  }

  saveContent() {
    this.dialogRef.close(this.selectedItems);
  }
}
